import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { blue } from "@material-ui/core/colors";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { formValueSelector } from "redux-form/immutable";

import { MARKER_FORM } from "features/planner/planner.constants";
import Marker from "features/planner/components/Card/EmployeeCard/Marker";

const ModalTabsMarker = ({ name = "", icon, classes, openFileDialog }) => (
  <Grid container alignItems="center" direction="column">
    <Grid item>
      <Marker marker={{ name, icon }} size={40} />
    </Grid>
    <Grid item container alignItems="center" direction="column">
      <Typography
        variant="caption"
        color="primary"
        justifyContent="center"
        onClick={openFileDialog}
        className={classes.text}
      >
        {icon ? "Change" : "Select icon"}
      </Typography>
      <Typography variant="caption" color="primary">
        {"*size less than 4kb"}
      </Typography>
    </Grid>
  </Grid>
);

const editMarkerFormSelector = formValueSelector(MARKER_FORM.ID);

const styles = () => ({
  text: {
    color: blue[900],
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
});

export default compose(
  connect(state => ({
    icon: editMarkerFormSelector(state, MARKER_FORM.ICON),
    name: editMarkerFormSelector(state, MARKER_FORM.NAME),
  })),
  withStyles(styles),
)(ModalTabsMarker);
